// extracted by mini-css-extract-plugin
export default {"head":"ResumeInvoiceCard_head__n9+ty","footer":"ResumeInvoiceCard_footer__S0hKz","description":"ResumeInvoiceCard_description__4l1wF","card":"ResumeInvoiceCard_card__iL8XD"};